import React from 'react';
import s from './TeamSlideItem.module.scss';

const TeamSlideItem = ({images, id, allBig}) => {
  // последний элементв стопке 1 тоже проблема
  if (allBig) { //если 375px то все большие одного размера
    return (
      <div className={s.teamSlideWrapper}>
        <div className={s.bigImgWrapper}>
          <img className={s.bigImg} src={images} alt={`team big img ${id}`} />
        </div>
      </div>)}


  let getTypeImg = (images, id) => {
    if (images.length !== 1) {
      return 'middle' //слайд с четырьмя картинками
    }
    if (id === 0) {
      return 'first' //первый big slide
    }

    //одна картинка и не первая
    return 'lastOne' //последняя картинка, но одинокая одна из четырех
  }

  const typeImg = getTypeImg(images, id);

  let getImageWithWrapper = (typeImg) => {
    switch (typeImg) {
      case 'first':
        return (<>
          <div className={s.bigImgWrapper}>
            <img className={s.bigImg} src={images} alt={`team big img 1`} />
          </div>
        </>);
  
      case 'middle': 
        const fourImages = images.map((src, index) => 
          <div className={s.miniImgWrapper} key={`mini-image-${index + 1}`}>
            <img className={s.miniImg} src={src} alt={`team mini img ${index + 1}`} />
          </div>)
        return (
          <div className={s.fourImages}>
            {fourImages}
          </div>)
  
      case 'lastOne':
        return (<>
          <div className={s.miniImgWrapper}>
            <img className={s.miniImg} src={images} alt={`team mini img last`} />
          </div>
        </>);
  
      
      default:
        const fourImages_ = images.map((src, index) => 
          <div className={s.miniImgWrapper} key={`mini-image-${index + 1}`}>
            <img className={s.miniImg} src={src} alt={`team mini img ${index + 1}`} />
          </div>)
        return (
          <div className={s.fourImages}>
            {fourImages_}
          </div>)
  
    } 
  }

  const imagesWithWrapper = getImageWithWrapper(typeImg);
  


  return (
    <div className={s.teamSlideWrapper}>
      {imagesWithWrapper}
    </div>
  )
}

export default TeamSlideItem;